import {useMemo} from 'react'
import useRouter from 'hooks/useRouter'
import {Box, TradingView} from '@binance/uikit'
import {TICK_SIZE} from 'constants'
import DataFeed from './DataFeed'

function CandlestickChart (props) {
  const router = useRouter()
  const {symbol, lng} = router.query

  return useMemo(
    () => (
      <Box flex={1} position="relative" style={{display: props.hidden && 'none'}}>
        <TradingView
          ticker={{symbol}}
          locale={lng}
          lineType={props.lineType}
          interval={props.interval}
          showIndicatorsDialog={props.showIndicatorsDialog}
          libraryPath="/tradingview"
          DataFeed={new DataFeed(TICK_SIZE)}
        />
      </Box>
    ),
    [props.hidden, props.lineType, props.interval, props.showIndicatorsDialog, symbol, lng]
  )
}

export default CandlestickChart
